
export const COMPANY_SIZES = [
    {
      label: "1",
      value: "1",
    },
    {
      label: "2-5",
      value: "2-5",
    },
    {
      label: "6-20",
      value: "6-20",
    },
    {
      label: "21-100",
      value: "21-100",
    },
    {
      label: "100+",
      value: "100+",
    },
  ];
  